import React from "react";
import {
  StyleSheet,
  StyleProp,
  TextStyle,
  TouchableOpacity,
  View,
  ViewStyle,
} from "react-native";
import Icon from "react-icons-kit";
import {
  upduoPrimaryBlack,
  upduoPrimaryBlue,
  upduoBlueBackground,
  upduoLighterGray,
  upduoLightestGray,
  upduoMediumLightGray,
} from "config/UpduoColors";
import { Text } from "UpduoLibrary";

export const dashboardStyles = StyleSheet.create({
  dashboardWidget: {
    backgroundColor: "white",
    borderRadius: 12,
    overflow: "hidden",
    borderStyle: "solid",
    borderColor: upduoLightestGray,
    borderWidth: 1,
    display: "flex",
    flexDirection: "column",
  },
  widgetTitle: {
    color: upduoMediumLightGray,
    textTransform: "uppercase",
    fontSize: 12,
  },
});

export function DashboardWidgetItem({
  text,
  icon,
  styles,
  textStyles,
  isActive = false,
  onClick,
  border = "bottom",
}: {
  text: string;
  icon: any;
  isActive?: boolean;
  styles?: StyleProp<ViewStyle>;
  textStyles?: StyleProp<TextStyle>;
  onClick?: () => void;
  border?: "top" | "bottom" | "none";
}) {
  const textColor = isActive ? upduoPrimaryBlue : upduoPrimaryBlack;
  const backgroundColor = isActive ? upduoBlueBackground : "white";
  const iconColor = isActive ? textColor : upduoLighterGray;
  return (
    <TouchableOpacity
      style={[
        {
          width: "100%",
          display: "flex",
          flexDirection: "row",
          backgroundColor: backgroundColor,
          borderColor: upduoLightestGray,
          borderBottomWidth: border === "bottom" ? 1 : undefined,
          borderTopWidth: border === "top" ? 1 : undefined,
          borderStyle: "solid",
          paddingHorizontal: 20,
          paddingVertical: 10,
          //@ts-ignore
          cursor: onClick ? "pointer" : undefined,
        },
        styles,
      ]}
      disabled={!onClick}
      onPress={onClick}
    >
      <Icon
        icon={icon}
        style={{ marginRight: 6, verticalAlign: "middle", color: iconColor }}
        size={24}
      />
      <Text
        style={[
          {
            color: textColor,
          },
          textStyles,
        ]}
        ellipsizeMode={"tail"}
        numberOfLines={1}
      >
        {text}
      </Text>
    </TouchableOpacity>
  );
}

export function Divider() {
  return (
    <View
      style={{
        width: "100%",
        height: 2,
        backgroundColor: upduoLightestGray,
      }}
    />
  );
}
